import { defineComponent as _defineComponent } from 'vue'
import ImageUpload from '@/components/image-upload.vue'
import { LibAppType, LibLoginType } from '@/consts'
import _ from 'lodash'
import { computed, watch } from 'vue'
import store from '../lib.store'
import DeviceOrgRefGroup from '../shared/device-org-ref-group.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-form',
  setup(__props, { expose }) {

const BaseRequired = { required: true, message: '请填写' }

const edit = store.edit

watch(
  () => edit.data.lend_way,
  () => {
    if (!~edit.data.lend_way.indexOf('BY_SHELF')) {
      edit.data.show_lend_info = false
    }
  }
)

const rules = {
  device_type: [{ type: 'array', ...BaseRequired, message: '请选择' }],
  login_type: [{ type: 'array', ...BaseRequired, message: '请选择' }],
  third_login_url: [BaseRequired, { type: 'url', message: '请输入正确的URL' }],
  manage_config_pwd: [{ ...BaseRequired }, { min: 5, message: '至少5位密码' }],
  app_name: [{ ...BaseRequired }],
  app_image: [{ ...BaseRequired, message: '请选择' }]
}

const hasDeviceReader = computed(() => {
  return _.includes(edit.data.device_type, 'READER')
})

function loginTypeChange(val) {
  if (~val.indexOf(3)) {
    edit.data.login_type = [3]
  }
}
function getForm() {
  return this.$refs.form
}
expose({ getForm })

function onAppCheckAllChange(checked) {
  if (checked) {
    edit.data.applications = LibAppType.map(it => it.value)
  } else {
    edit.data.applications = []
  }
}

return { __sfc: true,BaseRequired, edit, rules, hasDeviceReader, loginTypeChange, getForm, onAppCheckAllChange, ImageUpload, LibAppType, LibLoginType, DeviceOrgRefGroup }
}

})